import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolesLayoutComponent } from './overview/layout/roles-layout.component';
import { EntityPermissionGuard, AskToDeactivateGuard } from '@kpd/framework-ngx';
import { RoleDetailsComponent } from './detail/role-details.component';
import { EntityResolverTypes } from '../app.entity.resolvers';
import { titleFunction } from 'app/app-routing.module';

const rolesRoutes: Routes = [
  {
    path: 'roles',
    component: RolesLayoutComponent,
    data: {
      routeName: 'roles',
      routePermissionPrefix: 'Role',
      breadCrumbData: { titleFunc: titleFunction('Roles') },
    },
    canActivate: [EntityPermissionGuard],
  },
  {
    path: 'roles/details/application/:application/role/:name',
    component: RoleDetailsComponent,
    data: {
      routeName: 'roleDetail',
      routeParentName: 'roles',
      routePermissionPrefix: 'Role',
      routePermissionPrefixTabs: { users: 'User.Role', permissionSets: 'Role.PermissionSet' },
      routePermissionId: 'name',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.role,
        titleEntityIdKeys: ['name', 'application'],
      },
      pageTitlePrefixFunc: titleFunction('Role'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(rolesRoutes)],
  exports: [RouterModule],
})
export class RolesRoutingModule {}
